import { YStack } from "tamagui";
import { useNavigate } from "react-router-dom";
import { useCusAuth } from "@utils/store/auth/useCusAuth";
import { useEffect, useState } from "react";
import api, { handleRequest } from "@services/axios/apiManager";
import { AxiosResponse, AxiosError } from "axios";
import { useUser, IdentitySupplier } from "@utils/store/user/useUser";
import { buildXContextHeader } from "@utils/api/headers";
import GasStationList from "./components/GasStationList";
import { PageLoading } from "@components/loading/PageLoading";

export const GasShopStation = () => {
  const { cusJwtToken } = useCusAuth();
  const { chooseIdentity } = useUser();
  const [resStationList, setResStationList] = useState<IdentitySupplier[]>([]);
  // 換頁只用頁內 loading，不拉全域遮罩（見 components/loading/PageLoading.tsx）
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    handleRequest({
      asyncRequest: () =>
        api.get("/app-api/platform-order-drafts/bootstrap", {
          headers: { Authorization: `Bearer ${cusJwtToken}`, "X-Context": buildXContextHeader(chooseIdentity) },
        }),
      successCallback: (res: AxiosResponse) => {
        const { data } = res.data;
        setResStationList(data?.available_suppliers || []);
      },
      errorCallback: (error: any) => {
        console.log("err", error);
        setResStationList([]);
      },
      finalCallback: () => {
        setLoading(false);
      },
    });
  }, []);

  return (
    <YStack flex={1} justifyContent="space-between">
      {loading && resStationList.length === 0 ? <PageLoading label="載入瓦斯行" minHeight={220} /> : <GasStationList list={resStationList} />}
    </YStack>
  );
};

export default GasShopStation;
